import 'babel-polyfill'
import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import store from './store';
import moment from 'moment'
import { setupGlobalErrorHandler } from './composables/useErrorHandler';

// Install Composition API plugin for Vue 2
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

// Setup global error handler
setupGlobalErrorHandler({
  vue: Vue,
  router,
  store,
  onError: (error, context) => {
    // Log to console in development
    // Removed for production build
    
    // TODO: Send to error tracking service in production
    // Example: if (process.env.NODE_ENV === 'production') {
    //   Sentry.captureException(error, { extra: context });
    // }
  },
});

new Vue({
  store,
  router,
  vuetify,
  moment,
  render: h => h(App)
}).$mount('#app')
